import { useMutation, useQueryClient } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { CancelationReasons } from '../components/Modals/CancelModal/helper'

export type CancelationReason = (typeof CancelationReasons)[number]

export type CancelPlan = {
  currentPeriodEnd: number
  subscriptionId: string
}
export type CancelPlanRequestProps = { reason: CancelationReason; description: string }

const deletePlan = ({ reason, description }: CancelPlanRequestProps) => {
  const accountId = useUserStore.getState().accountId

  return request<{ data: CancelPlan }>({
    url: `accounts/${accountId}/subscriptions?cancelAtPeriodEnd=true&reason=${reason}&description=${description}`,
    method: 'DELETE',
  })
}

export const useCancelPlan = () => {
  const queryClient = useQueryClient()
  return useMutation(deletePlan, {
    onSuccess: () => {
      void queryClient.invalidateQueries(['accountSettings'])
      void queryClient.invalidateQueries(['creditCard'])
      void queryClient.invalidateQueries(['users'])
      void queryClient.invalidateQueries(['getPlansDetails'])
      void queryClient.invalidateQueries(['getPackagesLimits'])
    },
  })
}
